import { render, staticRenderFns } from "./VacancySalary.htm?vue&type=template&id=2ec8dc2e&scoped=true&"
import script from "./VacancySalary.ts?vue&type=script&lang=js&"
export * from "./VacancySalary.ts?vue&type=script&lang=js&"
import style0 from "./VacancySalary.scss?vue&type=style&index=0&id=2ec8dc2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec8dc2e",
  null
  
)

export default component.exports